module.exports = __webpack_public_path__ + "img/sortdown.816f6747.svg";